import React from "react";
import { Link } from "react-router-dom";

const SectionTeam = ({ Items }) => (
  <div className="container">
    <div
      className="custom-grid"
      style={{
        display: "flex",
        flexWrap: "wrap",
        marginLeft: "-10px",
        marginRight: "-10px",
      }}
    >
      {Items.slice(10, 50).map(({ id, title, imageUrl, desc, name, link }) => (
        <div
          key={id}
          className="team-card"
          style={{
            width: "33.3333%", // 3 columns
            padding: "5px 10px", // controls spacing between cards, not to the row edges
            boxSizing: "border-box",
          }}
        >
          <div className="dlab-box team-1 h-100">
            <div
              className="dlab-media d-flex justify-content-center"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img
                src={imageUrl}
                alt={name}
                style={{ height: "270px", objectFit: "contain" }}
              />
            </div>
            <div className="p-3">
              <p className="dlab-title text-uppercase mb-1">{title}</p>
              <h4 className="dlab-title text-uppercase">{name}</h4>
              <span className="dlab-member-position d-block mb-2">
                {desc.substring(0, 100)}...
              </span>
              <ul className="dlab-social-icon list-inline">
                <li className="list-inline-item">
                  <a href="#" className="fa fa-facebook site-button"></a>
                </li>
                <li className="list-inline-item">
                  <a href="#" className="fa fa-twitter site-button"></a>
                </li>
                <li className="list-inline-item">
                  <Link
                    to={link}
                    className="fa text-white text-center"
                    style={{
                      backgroundColor: "#CCA643",
                      width: "80px",
                      padding: "5px",
                      display: "inline-block",
                    }}
                  >
                    View More
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SectionTeam;
